"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerticalStep = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const StyledStep = styled_components_1.default.div `
  position: relative;
  display: flex;
  align-items: center;
  padding: 16px;
  color: #999;
  cursor: pointer;
  &.completed,
  &.selected {
    color: #555;
    .step-number {
      border-color: #039be5;
      color: #000;
      font-weight: 500;
    }
  }
  &.selected {
    background: #e1f5fe;
    color: #000;
    font-weight: 500;
  }
  .step-index {
    margin-right: 12px;
  }
  .step-number {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    min-width: 28px;
    max-width: 28px;
    border-radius: 100%;
    border: 2px solid rgba(0, 0, 0, 0.12);
    background: #fafafa;
    font-size: 12px;
    z-index: 1;
    box-sizing: border-box;
  }

  /* line connector */
  &:not(:first-child) {
    .step-index:before {
      position: absolute;
      top: 0;
      display: block;
      content: '';
      border-left: 1px solid rgba(0, 0, 0, 0.12);
      width: 1px;
      height: 50%;
      left: 29px;
      z-index: 0;
    }
  }
  &:not(:last-child) {
    .step-index:after {
      position: absolute;
      bottom: 0;
      display: block;
      content: '';
      border-left: 1px solid rgba(0, 0, 0, 0.12);
      width: 1px;
      height: 50%;
      left: 29px;
      z-index: 0;
    }
  }
`;
const VerticalStep = props => {
    const { label, step, completed, className, selected, onClick } = props;
    const classes = ['step'];
    className && classes.push(className);
    completed && classes.push('completed');
    selected && classes.push('selected');
    return (react_1.default.createElement(StyledStep, { className: classes.join(' '), onClick: onClick },
        react_1.default.createElement("div", { className: 'step-index' },
            react_1.default.createElement("span", { className: 'step-number' }, step)),
        react_1.default.createElement("div", { className: 'step-title' }, label)));
};
exports.VerticalStep = VerticalStep;
exports.default = exports.VerticalStep;
//# sourceMappingURL=VerticalStep.js.map